<template>
    <div class="institute-page">
        <SiteHeader />

        <img src="@/assets/1747793251984.jpg" alt="main image" class="main-image">

        <div class="institute-content">
            <div class="content-section introduction-section">
                <h2>详细介绍 <span class="english-subtitle">Introduce</span></h2>
                <div class="intro-layout">
                    <div class="left-sidebar">
                        <button class="intro-button">兰台简介</button>
                    </div>
                    <div class="right-content">
                        <p v-html="introductionText"></p>
                    </div>
                </div>
            </div>
        </div>
        <SiteFooter />
    </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { getLtLanTaiDaList } from '@/api/website.js'

export default {
    name: 'InstitutePage',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            introductionText: ''
        }
    },
    mounted() {
        this.fetchIntroduction();
    },
    methods: {
        async fetchIntroduction() {
            try {
                const response = await getLtLanTaiDaList();
                if (response.code === 200 && response.rows.length > 0) {
                    this.introductionText = response.rows[0].introduce;
                } else {
                    console.error('Failed to fetch introduction data:', response.msg);
                    this.introductionText = '未能获取到简介内容。';
                }
            } catch (error) {
                console.error('Error calling getLtLanTaiDaList:', error);
                this.introductionText = '加载简介内容时发生错误。';
            }
        }
    }
}
</script>

<style scoped>
.main-image {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
}

.banner-area {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 5%;
    background-color: #f5f7fa;
    min-height: 350px;
    overflow: hidden;
}

.banner-text {
    display: none;
}

/* .banner-image {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    width: 100%;
    max-width: 800px;
    text-align: center;
    box-sizing: border-box;
}

.banner-image img {
    display: block;
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
} */

.top-area {
    display: none;
}

.introduction-section h2 {
    color: #333;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.introduction-section h2::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #3c4a6b;
}

.introduction-section .english-subtitle {
    font-size: 20px;
    color: #666;
    font-weight: normal;
}

.intro-layout {
    display: flex;
    gap: 40px;
}

.left-sidebar {
    flex: 0 0 150px;
}

.right-content {
    flex: 1;
    font-size: 16px;
    line-height: 1.8;
    color: #4a5568;
}

.intro-button {
    background-color: #3c4a6b;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
}

.intro-button:hover {
    background-color: #2c3e50;
}

.institute-page {
    min-height: 100vh;
    background-color: #f5f7fa;
}

.institute-banner {
    background: linear-gradient(135deg, #3c4a6b 0%, #2c3e50 100%);
    color: white;
    padding: 60px 20px;
    text-align: center;
    margin-bottom: 40px;
}

.institute-banner h1 {
    font-size: 36px;
    margin-bottom: 16px;
    font-weight: 600;
}

.banner-subtitle {
    font-size: 20px;
    opacity: 0.9;
}

.institute-content {
    max-width: 1200px;
    margin: -30px auto 0;
    padding: 0 20px 60px;
    position: relative;
    z-index: 1;
}

.content-section {
    background: white;
    border-radius: 12px;
    padding: 32px;
    margin-bottom: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.content-section h2 {
    color: #3c4a6b;
    font-size: 24px;
    margin-bottom: 24px;
    font-weight: 600;
}

.content-section p {
    font-size: 16px;
    line-height: 1.8;
    color: #4a5568;
}

.feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 24px;
    margin-top: 24px;
}

.feature-item {
    background: #f8fafc;
    padding: 24px;
    border-radius: 8px;
    text-align: center;
    transition: transform 0.2s;
}

.feature-item:hover {
    transform: translateY(-5px);
}

.feature-icon {
    font-size: 32px;
    margin-bottom: 16px;
}

.feature-item h3 {
    color: #3c4a6b;
    font-size: 18px;
    margin-bottom: 12px;
    font-weight: 600;
}

.feature-item p {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
}

@media (max-width: 768px) {
    .banner-area {
        flex-direction: column;
        padding: 20px 5%;
        min-height: auto;
    }

    .banner-text {
        display: none;
    }

    .institute-banner h1 {
        font-size: 28px;
        margin-bottom: 12px;
    }

    .banner-subtitle {
        font-size: 16px;
    }

    .institute-content {
        margin: -20px auto 0;
        padding: 0 15px 40px;
    }

    .content-section {
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 8px;
    }

    .content-section h2 {
        font-size: 20px;
        margin-bottom: 16px;
    }

    .content-section p {
        font-size: 15px;
        line-height: 1.7;
    }

    .english-subtitle {
        font-size: 14px;
        display: block;
        margin-top: 5px;
    }

    .intro-layout {
        flex-direction: column;
        gap: 20px;
    }

    .left-sidebar {
        flex: none;
        width: 100%;
        text-align: center;
    }

    .intro-button {
        width: auto;
        padding: 10px 20px;
        font-size: 14px;
    }

    .right-content {
        padding: 15px;
    }

    .feature-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .feature-item {
        padding: 20px;
    }

    .feature-icon {
        font-size: 28px;
    }

    .feature-item h3 {
        font-size: 16px;
    }

    .feature-item p {
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .institute-banner h1 {
        font-size: 24px;
    }

    .banner-subtitle {
        font-size: 14px;
    }

    .content-section {
        padding: 15px;
    }

    .content-section h2 {
        font-size: 18px;
    }

    .content-section p {
        font-size: 14px;
    }
}
</style>